import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { DollarCircleOutlined, ReadOutlined, FundOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';

const CashflowDash = () => import('@/views/cashflow/dashboard/index.vue');

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 *
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/cashflow',
    name: 'cashflow',
    redirect: '/cashflow/forecast',
    component: Layout,
    meta: {
      title: 'Cashflow',
      icon: renderIcon(DollarCircleOutlined),
      permissions: ['cashflow_forecast_read', 'cashflow_dashboard_read'],
      hidden: false,
      sort: 7,
    },
    children: [
      {
        path: 'forecast',
        name: 'cashflow_forecast',
        meta: {
          title: 'Forecast',
          icon: renderIcon(ReadOutlined),
          permissions: ['cashflow_forecast_read'],
        },
        component: () => import('@/views/cashflow/forecast/index.vue'),
      },
      {
        path: 'dashboard',
        name: 'cashflow_dashboard',
        meta: {
          title: 'Dashboard',
          spname: 'forecast_dashboard',
          icon: renderIcon(FundOutlined),
          permissions: ['cashflow_dashboard_read'],
        },
        component: CashflowDash,
      },
    ],
  },
];

export default routes;
